/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CostBreakdownV2,
    CostBreakdownV2FromJSON,
    CostBreakdownV2FromJSONTyped,
    CostBreakdownV2ToJSON,
} from './CostBreakdownV2';
import {
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './CurrencyCode';
import {
    DiscountV2,
    DiscountV2FromJSON,
    DiscountV2FromJSONTyped,
    DiscountV2ToJSON,
} from './DiscountV2';
import {
    Dispute,
    DisputeFromJSON,
    DisputeFromJSONTyped,
    DisputeToJSON,
} from './Dispute';
import {
    OrderItemV2,
    OrderItemV2FromJSON,
    OrderItemV2FromJSONTyped,
    OrderItemV2ToJSON,
} from './OrderItemV2';
import {
    OrderObjectType,
    OrderObjectTypeFromJSON,
    OrderObjectTypeFromJSONTyped,
    OrderObjectTypeToJSON,
} from './OrderObjectType';
import {
    OrderStatus,
    OrderStatusFromJSON,
    OrderStatusFromJSONTyped,
    OrderStatusToJSON,
} from './OrderStatus';
import {
    OrderV2AmountDiscounted,
    OrderV2AmountDiscountedFromJSON,
    OrderV2AmountDiscountedFromJSONTyped,
    OrderV2AmountDiscountedToJSON,
} from './OrderV2AmountDiscounted';
import {
    OrderV2AmountDue,
    OrderV2AmountDueFromJSON,
    OrderV2AmountDueFromJSONTyped,
    OrderV2AmountDueToJSON,
} from './OrderV2AmountDue';
import {
    OrderV2AmountFee,
    OrderV2AmountFeeFromJSON,
    OrderV2AmountFeeFromJSONTyped,
    OrderV2AmountFeeToJSON,
} from './OrderV2AmountFee';
import {
    OrderV2AmountPaid,
    OrderV2AmountPaidFromJSON,
    OrderV2AmountPaidFromJSONTyped,
    OrderV2AmountPaidToJSON,
} from './OrderV2AmountPaid';
import {
    OrderV2AmountRemaining,
    OrderV2AmountRemainingFromJSON,
    OrderV2AmountRemainingFromJSONTyped,
    OrderV2AmountRemainingToJSON,
} from './OrderV2AmountRemaining';
import {
    OrderV2AmountReturned,
    OrderV2AmountReturnedFromJSON,
    OrderV2AmountReturnedFromJSONTyped,
    OrderV2AmountReturnedToJSON,
} from './OrderV2AmountReturned';
import {
    OrderV2AmountSubtotal,
    OrderV2AmountSubtotalFromJSON,
    OrderV2AmountSubtotalFromJSONTyped,
    OrderV2AmountSubtotalToJSON,
} from './OrderV2AmountSubtotal';
import {
    OrderV2AmountTaxed,
    OrderV2AmountTaxedFromJSON,
    OrderV2AmountTaxedFromJSONTyped,
    OrderV2AmountTaxedToJSON,
} from './OrderV2AmountTaxed';
import {
    OrderV2AmountTotal,
    OrderV2AmountTotalFromJSON,
    OrderV2AmountTotalFromJSONTyped,
    OrderV2AmountTotalToJSON,
} from './OrderV2AmountTotal';
import {
    OrderV2EndingBalance,
    OrderV2EndingBalanceFromJSON,
    OrderV2EndingBalanceFromJSONTyped,
    OrderV2EndingBalanceToJSON,
} from './OrderV2EndingBalance';
import {
    OrderV2StartingBalance,
    OrderV2StartingBalanceFromJSON,
    OrderV2StartingBalanceFromJSONTyped,
    OrderV2StartingBalanceToJSON,
} from './OrderV2StartingBalance';
import {
    Payment,
    PaymentFromJSON,
    PaymentFromJSONTyped,
    PaymentToJSON,
} from './Payment';
import {
    Refund,
    RefundFromJSON,
    RefundFromJSONTyped,
    RefundToJSON,
} from './Refund';
import {
    TaxItemV2,
    TaxItemV2FromJSON,
    TaxItemV2FromJSONTyped,
    TaxItemV2ToJSON,
} from './TaxItemV2';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface OrderV2
 */
export interface OrderV2 {
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    id: string;
    /**
     * 
     * @type {OrderObjectType}
     * @memberof OrderV2
     */
    object: OrderObjectType;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    program_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    program_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    contact_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    contact_name: string;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    contact_email: string;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    customer_id?: string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderV2
     */
    status: OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    receipt_number: string;
    /**
     * 
     * @type {OrderV2AmountFee}
     * @memberof OrderV2
     */
    amount_fee: OrderV2AmountFee;
    /**
     * 
     * @type {OrderV2AmountReturned}
     * @memberof OrderV2
     */
    amount_returned: OrderV2AmountReturned;
    /**
     * 
     * @type {OrderV2AmountSubtotal}
     * @memberof OrderV2
     */
    amount_subtotal: OrderV2AmountSubtotal;
    /**
     * 
     * @type {OrderV2AmountTaxed}
     * @memberof OrderV2
     */
    amount_taxed: OrderV2AmountTaxed;
    /**
     * 
     * @type {OrderV2AmountTotal}
     * @memberof OrderV2
     */
    amount_total: OrderV2AmountTotal;
    /**
     * 
     * @type {OrderV2AmountPaid}
     * @memberof OrderV2
     */
    amount_paid: OrderV2AmountPaid;
    /**
     * 
     * @type {OrderV2AmountDue}
     * @memberof OrderV2
     */
    amount_due: OrderV2AmountDue;
    /**
     * 
     * @type {OrderV2AmountRemaining}
     * @memberof OrderV2
     */
    amount_remaining: OrderV2AmountRemaining;
    /**
     * 
     * @type {OrderV2AmountDiscounted}
     * @memberof OrderV2
     */
    amount_discounted: OrderV2AmountDiscounted;
    /**
     * 
     * @type {CostBreakdownV2}
     * @memberof OrderV2
     */
    cost_breakdown: CostBreakdownV2;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof OrderV2
     */
    currency: CurrencyCode;
    /**
     * 
     * @type {Array<OrderItemV2>}
     * @memberof OrderV2
     */
    items: Array<OrderItemV2>;
    /**
     * 
     * @type {Array<TaxItemV2>}
     * @memberof OrderV2
     */
    tax_items: Array<TaxItemV2>;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof OrderV2
     */
    payments: Array<Payment>;
    /**
     * 
     * @type {Array<Refund>}
     * @memberof OrderV2
     */
    refunds: Array<Refund>;
    /**
     * 
     * @type {Array<DiscountV2>}
     * @memberof OrderV2
     */
    discounts: Array<DiscountV2>;
    /**
     * 
     * @type {Array<Dispute>}
     * @memberof OrderV2
     */
    disputes: Array<Dispute>;
    /**
     * 
     * @type {OrderV2StartingBalance}
     * @memberof OrderV2
     */
    starting_balance: OrderV2StartingBalance;
    /**
     * 
     * @type {OrderV2EndingBalance}
     * @memberof OrderV2
     */
    ending_balance: OrderV2EndingBalance;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof OrderV2
     */
    timezone: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderV2
     */
    created: Date;
    /**
     * 
     * @type {User}
     * @memberof OrderV2
     */
    created_by: User;
    /**
     * 
     * @type {Date}
     * @memberof OrderV2
     */
    updated?: Date;
    /**
     * 
     * @type {User}
     * @memberof OrderV2
     */
    updated_by?: User;
}

export function OrderV2FromJSON(json: any): OrderV2 {
    return OrderV2FromJSONTyped(json, false);
}

export function OrderV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object': OrderObjectTypeFromJSON(json['object']),
        'program_id': json['program_id'],
        'program_name': json['program_name'],
        'contact_id': json['contact_id'],
        'contact_name': json['contact_name'],
        'contact_email': json['contact_email'],
        'customer_id': !exists(json, 'customer_id') ? undefined : json['customer_id'],
        'status': OrderStatusFromJSON(json['status']),
        'receipt_number': json['receipt_number'],
        'amount_fee': OrderV2AmountFeeFromJSON(json['amount_fee']),
        'amount_returned': OrderV2AmountReturnedFromJSON(json['amount_returned']),
        'amount_subtotal': OrderV2AmountSubtotalFromJSON(json['amount_subtotal']),
        'amount_taxed': OrderV2AmountTaxedFromJSON(json['amount_taxed']),
        'amount_total': OrderV2AmountTotalFromJSON(json['amount_total']),
        'amount_paid': OrderV2AmountPaidFromJSON(json['amount_paid']),
        'amount_due': OrderV2AmountDueFromJSON(json['amount_due']),
        'amount_remaining': OrderV2AmountRemainingFromJSON(json['amount_remaining']),
        'amount_discounted': OrderV2AmountDiscountedFromJSON(json['amount_discounted']),
        'cost_breakdown': CostBreakdownV2FromJSON(json['cost_breakdown']),
        'currency': CurrencyCodeFromJSON(json['currency']),
        'items': ((json['items'] as Array<any>).map(OrderItemV2FromJSON)),
        'tax_items': ((json['tax_items'] as Array<any>).map(TaxItemV2FromJSON)),
        'payments': ((json['payments'] as Array<any>).map(PaymentFromJSON)),
        'refunds': ((json['refunds'] as Array<any>).map(RefundFromJSON)),
        'discounts': ((json['discounts'] as Array<any>).map(DiscountV2FromJSON)),
        'disputes': ((json['disputes'] as Array<any>).map(DisputeFromJSON)),
        'starting_balance': OrderV2StartingBalanceFromJSON(json['starting_balance']),
        'ending_balance': OrderV2EndingBalanceFromJSON(json['ending_balance']),
        'language': json['language'],
        'timezone': json['timezone'],
        'created': (new Date(json['created'])),
        'created_by': UserFromJSON(json['created_by']),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'updated_by': !exists(json, 'updated_by') ? undefined : UserFromJSON(json['updated_by']),
    };
}

export function OrderV2ToJSON(value?: OrderV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'object': OrderObjectTypeToJSON(value.object),
        'program_id': value.program_id,
        'program_name': value.program_name,
        'contact_id': value.contact_id,
        'contact_name': value.contact_name,
        'contact_email': value.contact_email,
        'customer_id': value.customer_id,
        'status': OrderStatusToJSON(value.status),
        'receipt_number': value.receipt_number,
        'amount_fee': OrderV2AmountFeeToJSON(value.amount_fee),
        'amount_returned': OrderV2AmountReturnedToJSON(value.amount_returned),
        'amount_subtotal': OrderV2AmountSubtotalToJSON(value.amount_subtotal),
        'amount_taxed': OrderV2AmountTaxedToJSON(value.amount_taxed),
        'amount_total': OrderV2AmountTotalToJSON(value.amount_total),
        'amount_paid': OrderV2AmountPaidToJSON(value.amount_paid),
        'amount_due': OrderV2AmountDueToJSON(value.amount_due),
        'amount_remaining': OrderV2AmountRemainingToJSON(value.amount_remaining),
        'amount_discounted': OrderV2AmountDiscountedToJSON(value.amount_discounted),
        'cost_breakdown': CostBreakdownV2ToJSON(value.cost_breakdown),
        'currency': CurrencyCodeToJSON(value.currency),
        'items': ((value.items as Array<any>).map(OrderItemV2ToJSON)),
        'tax_items': ((value.tax_items as Array<any>).map(TaxItemV2ToJSON)),
        'payments': ((value.payments as Array<any>).map(PaymentToJSON)),
        'refunds': ((value.refunds as Array<any>).map(RefundToJSON)),
        'discounts': ((value.discounts as Array<any>).map(DiscountV2ToJSON)),
        'disputes': ((value.disputes as Array<any>).map(DisputeToJSON)),
        'starting_balance': OrderV2StartingBalanceToJSON(value.starting_balance),
        'ending_balance': OrderV2EndingBalanceToJSON(value.ending_balance),
        'language': value.language,
        'timezone': value.timezone,
        'created': (value.created.toISOString()),
        'created_by': UserToJSON(value.created_by),
        'updated': value.updated === undefined ? undefined : (value.updated.toISOString()),
        'updated_by': UserToJSON(value.updated_by),
    };
}

